import axios from './axiosConfig';
import { getProfile } from "./profileActions";
import { useDispatch, useSelector } from 'react-redux';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo1.raborisk.ai"
  : "http://localhost:3000";




  let cachedUserId = null

  export const logAction = async (dispatch, getState, actionType, description = null) => {
    //////console.log("Loggin")
    try {
      if (cachedUserId == null) {
        // Use your existing getProfile action via dispatch
        await dispatch(getProfile());  // <-- call your existing Redux action
        ////console.log(getState())
        const state = getState(); // <-- get user from Redux state
        cachedUserId = state.profile.profile.user_id;
      }
      
      ////console.log("Loggin2")
      axios.post(API_URL + '/api/log', {
        userId: cachedUserId,
        actionType,
        description
      });
      if(actionType === "LOGOUT"){
        cachedUserId = null;
      }
    } catch (error) {
      console.error('Failed to log action:', error);
    }
};

export const resetLoggerCache = () => {
  cachedUserId = null;
};